import { isNotEmptyValue } from "kwikid-toolkit";
import {
  TKwikUIInputFileSize,
  TKwikUIInputFileVariant,
  VKwikUIInputFileSize,
  VKwikUIInputFileVariant
} from "./input-files.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isNumber = (x: number) => typeof x === "number";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    accept: (x: string) => isString(x) && isNotEmptyValue(x),
    disabled: isBoolean,
    formControlName: (x: string) => isString(x) && isNotEmptyValue(x),
    icon: (x: string) => isString(x) && isNotEmptyValue(x),
    id: (x: string) => isString(x) && isNotEmptyValue(x),
    label: (x: string) => isString(x) && isNotEmptyValue(x),
    link: (x: string) => isString(x) && isNotEmptyValue(x),
    maxFileSize: isNumber,
    multiple: isBoolean,
    showAddedFiles: isBoolean,
    size: (x: TKwikUIInputFileSize) => VKwikUIInputFileSize.includes(x),
    variant: (x: TKwikUIInputFileVariant) => VKwikUIInputFileVariant.includes(x)
  };

  return methods[key] && methods[key](value);
};
